import { Col, Row, Space, Typography } from "antd";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import {
  convertDateStringToDateTimezone_7,
  getDateStringLocale,
} from "helper/common";
import moment from "moment";
import BoxBHYT from "pages/Pay/PayTab/ModalPrintPTT/BoxBHYT/BoxBHYT";
import React from "react";
import { FORMAT_TIME } from "types/enums";
const rowClassName = (key) => {
  const isNumber = /^\d+$/.test(key);
  return isNumber;
};

const ContentPrint = ({ data, thongTinIn, nuoctieu = [] }) => {
  return (
    <div className="print-container">
      <table style={{ width: "100%" }}>
        <thead>
          <tr style={{ height: "15px" }}></tr>
        </thead>
        <tbody>
          <Row
            style={{
              justifyContent: "space-between",
            }}
          >
            <Col>
              <Row justify={"center"}>
                <Typography.Text>BỘ Y TẾ</Typography.Text>
              </Row>
              <Row justify={"center"}>
                <Typography.Text>
                  BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                </Typography.Text>
              </Row>
            </Col>
            <Col style={{ paddingRight: "100px" }}>
              <Row>
                <Typography.Text>
                  Mã bệnh phẩm: {thongTinIn?.maBenhPham}
                </Typography.Text>
              </Row>

              <Row>
                <Typography.Text>
                  Mã bệnh nhân: {thongTinIn?.maBenhNhan}
                </Typography.Text>
              </Row>

              <Row>
                <Typography.Text>
                  Ngày lấy mẫu: &nbsp;
                  {thongTinIn?.thoiGianLayMau
                    ? dayjs(thongTinIn?.thoiGianLayMau).format(
                        "DD-MM-YYYY HH:mm:ss"
                      )
                    : ""}
                </Typography.Text>
              </Row>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Typography.Title
              style={{
                fontWeight: "700",
                fontSize: "20px",
              }}
            >
              PHIẾU KẾT QUẢ XÉT NGHIỆM
            </Typography.Title>
          </Row>
          <Row>
            <Row>
              <Col span={10}>
                <Typography.Text>
                  Họ và tên: &nbsp; <b>{thongTinIn?.hoTen}</b>
                </Typography.Text>
              </Col>
              <Col span={8}>
                <Typography.Text>
                  Ngày sinh: &nbsp;{" "}
                  {thongTinIn?.ngaySinh
                    ? `${convertDateStringToDateTimezone_7(
                        thongTinIn?.ngaySinh
                      ).format(FORMAT_TIME.dayFull)}`
                    : ""}
                </Typography.Text>
              </Col>
              <Col span={6}>
                <Typography.Text>
                  Giới tính: &nbsp;{" "}
                  {gioiTinhOptions.find(
                    (it) => it.value === thongTinIn?.gioiTinh
                  )?.label || ""}
                </Typography.Text>
              </Col>
            </Row>
          </Row>
          <Row>
            <Col span={14}>
              <Typography.Text>
                Địa chỉ: &nbsp; {thongTinIn?.diaChiTongHop}
              </Typography.Text>
            </Col>
            <Col span={10} style={{ display: "flex", alignItems: "center" }}>
              Mã thẻ BHYT: &nbsp;
              <BoxBHYT code={thongTinIn?.maTheBhyt ?? ""} />
            </Col>
          </Row>
          <Row>
            <Col span={10}> Khoa: &nbsp; Khoa mắt tổng hợp</Col>
            <Col span={8}>Buồng: &nbsp; {thongTinIn?.buongSo}</Col>
            <Col span={6}>Giường: &nbsp; {thongTinIn?.giuongSo}</Col>
          </Row>
          <Row>
            <Typography.Text>
              BS chỉ định: &nbsp; {thongTinIn?.bacSyChiDinh}
            </Typography.Text>
          </Row>
          <Row>
            <Typography.Text>
              Chẩn đoán: &nbsp; {thongTinIn?.chanDoan}
            </Typography.Text>
          </Row>
          <Row>
            <Typography.Text>
              Ghi chú: &nbsp; {thongTinIn?.ghiChu}
            </Typography.Text>
          </Row>
          <div className="table-xet-nghiem-print">
            <table>
              <thead>
                <tr>
                  <th
                    style={{
                      width: "350px",
                    }}
                  >
                    Tên xét nghiệm
                  </th>
                  <th>Kết quả xét nghiệm</th>
                  <th>Giá trị tham chiếu</th>
                  <th>Đơn vị</th>
                </tr>
              </thead>
              <tbody>
                {data.map((e) => (
                  <>
                    <tr>
                      <th
                        style={{
                          textDecoration: "underline",
                          paddingLeft: "10px",
                        }}
                      >
                        {e.tenXetNghiem}
                      </th>
                      <td> </td>
                      <td> </td>
                      <td> </td>
                    </tr>
                    <tr></tr>
                    {e.children.map((item) => (
                      <>
                        {!rowClassName(item.key) && (
                          <tr>
                            <td id="padding-left">{item.tenXetNghiem}</td>
                            <td> </td>
                            <td> </td>
                            <td> </td>
                          </tr>
                        )}

                        {item.children.map((childItem) => (
                          <tr>
                            <td id="padding-left">
                              {childItem.tenChiSoXetNghiem}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: childItem.isExceed ? "red" : "black",
                                fontWeight: childItem.isExceed ? "bold" : "",
                              }}
                            >
                              {childItem.giaTri}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {childItem.giaTriBinhThuong}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {childItem.donViTinh}
                            </td>
                          </tr>
                        ))}
                      </>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>

          <Row style={{ marginTop: "10px", paddingBottom: "20px" }}>
            <Row justify={"end"}>
              <Typography.Text
                className="date-sign"
                style={{ marginRight: "50px" }}
              >
                {getDateStringLocale(
                  thongTinIn?.thoiGianTraKetQua ?? moment().format()
                )}
              </Typography.Text>
            </Row>
            <Row justify={"end"}>
              <Col>
                <Space direction="vertical" size={35}>
                  <Row>
                    <Row justify={"center"}>
                      <Typography.Text strong>
                        Trưởng khoa xét nghiệm
                      </Typography.Text>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Text type="secondary">
                        (Ký và ghi rõ họ tên)
                      </Typography.Text>
                    </Row>
                  </Row>
                  <Row justify={"center"}>
                    <Typography.Text strong>
                      {thongTinIn?.truongKhoaXetNghiem
                        ? `Ths. ${thongTinIn?.truongKhoaXetNghiem}`
                        : localStorage.getItem("fullName")}
                    </Typography.Text>
                  </Row>
                </Space>
              </Col>
            </Row>
          </Row>
        </tbody>
        {/* <tfoot>
          <tr style={{ height: "15px" }}></tr>
        </tfoot> */}
      </table>
    </div>
  );
};

export default ContentPrint;
